import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { WorkoutCardSkeleton } from 'src/component/ui/workout-card/workout-card-skeleton'

export const CoreChargeWorkoutHomeCardListSkeleton = (): React.ReactElement => {
  return (
    <Container fluid className="px-0">
      <Row className="g-4">
        <Col xs={12} lg={6} className="mb-7 lg:mb-0">
          <WorkoutCardSkeleton />
        </Col>
        <Col xs={12} lg={3} className="mb-7 lg:mb-0">
          <WorkoutCardSkeleton />
        </Col>
        <Col xs={12} lg={3}>
          <WorkoutCardSkeleton />
        </Col>
      </Row>
    </Container>
  )
}
